import React, { Component } from 'react';

class Footer extends Component{
  render() {
    return (
      <div className="foo">
          <div className="container ">
          <h5>Visit Again</h5>
          </div>
      </div>
     
    );
}
}
export default Footer;
